const i18n = {
  'quotation': {
    'table': {
      'date': '建立日期'
    }
  }
}
export default i18n
